import * as React from 'react';

import styled from 'styled-components';

import { Button, ButtonModel, Input } from '@notino/react-styleguide';

type Props = {
  onSubmit: (value: { nickname: string; email: string }) => void;
};

export const NicknameModal = ({ onSubmit }: Props) => {
  const [nickname, setNickname] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = () => {
    onSubmit({ nickname, email });
    setLoading(true);
  };

  return (
    <Wrapper>
      <Input
        placeholder="Nickname"
        value={nickname}
        onChange={(e) => setNickname(e.target.value)}
      />
      <Input
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <Button
        disabled={!nickname || !email}
        onClick={handleSubmit}
        buttonStyle={ButtonModel.Styles.primary}
      >
        {loading ? 'Loading...' : 'Submit'}
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
